export enum UserActionEventType {
  AgentRejected = 'agent.rejected',
  AgentHoldStarted = 'agent.holdStarted',
  AgentHoldEnded = 'agent.holdEnded',
}

export enum UserActionDeviceType {
  Web = 'Web',
  Mobile = 'Mobile',
  DeskPhone = 'DeskPhone',
}

export interface UserActionEvent {
  eventId: string;
  kazooCallId: string;
  event: UserActionEventType;
  timestamp: Date;
  deviceType: UserActionDeviceType;
  userId: string;
  retryCount?: number;
}
